import { UNIT_METERS_PER_SECOND, UNIT_KILOMETER, UNIT_HECTOPASCAL, UNIT_METER, UNIT_FOOT, UNIT_FLIGHT_LEVEL, UNIT_PERCENTAGE, UNIT_CELCIUS, UNIT_KNOT, UNIT_SECOND, UNIT_MILE, UNIT_NAUTICAL_MILE, UNIT_FEET_PER_MIN, UNIT_KILOMETERS_PER_HOUR, UNIT_MILES_PER_HOUR, UNIT_FAHREINHEIT, UNIT_KELVIN, UNIT_INCHES_OF_MERCURY, UNIT_MILLIBAR, UNIT_MILLIMETER, UNIT_CENTIMETER, UNIT_INCH, UNIT_DEGREE, UNIT_DMS, UNIT_KILO_GRAM, UNIT_POUND, UNIT_TONNE, UNIT_NANO_GRAM, UNIT_MICRO_GRAM, UNIT_MILLI_GRAM, UNIT_GRAM, UNIT_TERA_GRAM, UNIT_GIGA_GRAM, UNIT_KILO_US_TONNE, UNIT_MEGA_US_TONNE, UNIT_OUNCE, UNIT_MILLI_OUNCE, UNIT_MICRO_OUNCE, UNIT_NANO_OUNCE, UNIT_PICO_OUNCE, UNIT_GIGA_US_TONNE, UNIT_TERA_US_TONNE, UNIT_PETA_US_TONNE, UNIT_PICO_GRAM, UNIT_PETA_GRAM, UNIT_US_TONNE, KILOGRAM_TO_POUNDS_CONVERSION_FACTOR, POUNDS_TO_OUNCE_CONVERSION_FACTOR, } from '../constants';
import { meterToKilometer, meterToFoot, metersPerSecondToKnot, meterToMile, meterToNauticalMile, footToMeter, metersPerSecondToFeetPerMinute, metersPerSecondToKilometersPerHour, metersPerSecondToMilesPerHour, celciusToFahreinheit, hectopascalToInchesOfMercury, millimeterToCentimeter, millimeterToMeter, millimeterToInch, degreeToDms, footToFlightLevel, kilogramToPound, } from './converter';
export const isValidNum = (value) => {
    return typeof value === 'number';
};
export const formatNumberToString = (value, decimals) => {
    const options = {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    };
    return value.toLocaleString('en', options);
};
// Default unit: m
// Other allowed units: km, mi, NI, ft
// The 'decimals' parameter has a special case: when set to -1, the function
// returns two decimal places for values < 100 and one decimal place
// for values >= 100.
export const getConvertedDistance = (distanceInMetres, requiredUnit, decimals) => {
    if (!isValidNum(distanceInMetres)) {
        return '';
    }
    switch (requiredUnit) {
        case UNIT_KILOMETER || UNIT_METER:
        default: {
            if (distanceInMetres < 10000) {
                return `${formatNumberToString(distanceInMetres, 0)} ${UNIT_METER}`;
            }
            else {
                const distanceInKilometres = meterToKilometer(distanceInMetres);
                if (decimals === -1) {
                    decimals = distanceInKilometres < 100 ? 2 : 1;
                }
                return `${formatNumberToString(distanceInKilometres, decimals)} ${UNIT_KILOMETER}`;
            }
        }
        case UNIT_MILE || UNIT_FOOT: {
            const distanceInMiles = meterToMile(distanceInMetres);
            const distanceInFeet = meterToFoot(distanceInMetres);
            if (distanceInFeet < 10000) {
                return `${formatNumberToString(distanceInFeet, 0)} ${UNIT_FOOT}`;
            }
            else {
                if (decimals === -1) {
                    decimals = distanceInMiles < 100 ? 2 : 1;
                }
                return `${formatNumberToString(distanceInMiles, decimals)} ${UNIT_MILE}`;
            }
        }
        case UNIT_NAUTICAL_MILE: {
            const distanceInNauticalMiles = meterToNauticalMile(distanceInMetres);
            const distanceInFeet = meterToFoot(distanceInMetres);
            if (distanceInFeet < 10000) {
                return `${formatNumberToString(distanceInFeet, 0)} ${UNIT_FOOT}`;
            }
            else {
                if (decimals === -1) {
                    decimals = distanceInNauticalMiles < 100 ? 2 : 1;
                }
                return `${formatNumberToString(distanceInNauticalMiles, decimals)} ${UNIT_NAUTICAL_MILE}`;
            }
        }
    }
};
// Default unit: ft
// Other allowed units: m
export const getConvertedVerticalDistance = (altitudeValue, requiredUnit, decimals, defaultUnit = 'ft') => {
    if (!isValidNum(altitudeValue)) {
        return '';
    }
    switch (requiredUnit) {
        case UNIT_METER: {
            const altitudeInMetres = defaultUnit === UNIT_FOOT ? footToMeter(altitudeValue) : altitudeValue;
            return `${formatNumberToString(altitudeInMetres, 0)} ${UNIT_METER}`;
        }
        case UNIT_FOOT:
        default: {
            const altitudeInFeet = defaultUnit === UNIT_METER ? meterToFoot(altitudeValue) : altitudeValue;
            if (altitudeInFeet < 10000) {
                return `${formatNumberToString(altitudeInFeet, 0)} ${UNIT_FOOT}`;
            }
            const altitudeInFlightLevel = footToFlightLevel(altitudeInFeet);
            return `${UNIT_FLIGHT_LEVEL} ${formatNumberToString(altitudeInFlightLevel, 0)}`;
        }
    }
};
// Default unit: m/s
// Other allowed units: km/h, mph, kt
export const getConvertedSpeed = (value, requiredUnit, decimals) => {
    if (!isValidNum(value)) {
        return '';
    }
    switch (requiredUnit) {
        case UNIT_KILOMETERS_PER_HOUR: {
            const convertedValue = metersPerSecondToKilometersPerHour(value);
            return `${formatNumberToString(convertedValue, decimals)} ${UNIT_KILOMETERS_PER_HOUR}`;
        }
        case UNIT_MILES_PER_HOUR: {
            // FIX THIS
            const convertedValue = metersPerSecondToMilesPerHour(value);
            return `${formatNumberToString(convertedValue, decimals)} ${UNIT_MILES_PER_HOUR}`;
        }
        case UNIT_KNOT: {
            const convertedValue = metersPerSecondToKnot(value);
            return `${formatNumberToString(convertedValue, decimals)} ${UNIT_KNOT}`;
        }
        case UNIT_METERS_PER_SECOND:
        default:
            return `${formatNumberToString(value, decimals)} ${UNIT_METERS_PER_SECOND}`;
    }
};
// Default unit: m/s
// Other allowed Units: ft/min
export const getConvertedVerticalSpeed = (value, requiredUnit, decimals) => {
    if (!isValidNum(value)) {
        return '';
    }
    switch (requiredUnit) {
        case UNIT_FEET_PER_MIN: {
            const convertedValue = metersPerSecondToFeetPerMinute(value);
            return `${formatNumberToString(convertedValue, decimals)} ${UNIT_FEET_PER_MIN}`;
        }
        case UNIT_METERS_PER_SECOND:
        default:
            return `${formatNumberToString(value, decimals)} ${UNIT_METERS_PER_SECOND}`;
    }
};
// Default unit: °C
// Other allowed Units: °F, K
export const getConvertedTemperature = (value, requiredUnit, decimals) => {
    if (!isValidNum(value)) {
        return '';
    }
    switch (requiredUnit) {
        case UNIT_FAHREINHEIT: {
            const convertedValue = celciusToFahreinheit(value);
            return `${formatNumberToString(convertedValue, decimals)}°${UNIT_FAHREINHEIT}`;
        }
        case UNIT_KELVIN: {
            const convertedValue = celciusToFahreinheit(value);
            return `${formatNumberToString(convertedValue, decimals)} ${UNIT_KELVIN}`;
        }
        case UNIT_CELCIUS:
        default:
            return `${formatNumberToString(value, decimals)}°${UNIT_CELCIUS}`;
    }
};
// Default unit: hPa
// Other allowed units: inHg, mb
export const getConvertedPressure = (value, requiredUnit, decimals) => {
    if (!isValidNum(value)) {
        return '';
    }
    switch (requiredUnit) {
        case UNIT_INCHES_OF_MERCURY: {
            const convertedValue = hectopascalToInchesOfMercury(value);
            return `${formatNumberToString(convertedValue, decimals)} ${UNIT_INCHES_OF_MERCURY}`;
        }
        case UNIT_MILLIBAR: {
            // 1hPa = 1mb;
            return `${formatNumberToString(value, decimals)} ${UNIT_MILLIBAR}`;
        }
        case UNIT_HECTOPASCAL:
        default:
            return `${formatNumberToString(value, decimals)} ${UNIT_HECTOPASCAL}`;
    }
};
// Default unit: %
export const getConvertedHumidity = (value, requiredUnit, decimals) => {
    if (!isValidNum(value)) {
        return '';
    }
    switch (requiredUnit) {
        case UNIT_PERCENTAGE:
        default:
            return `${formatNumberToString(value, decimals)}${UNIT_PERCENTAGE}`;
    }
};
// Default unit: m
// Other allowed units: mi, ft, km
export const getConvertedVisibility = (value, requiredUnit, decimals) => {
    if (!isValidNum(value)) {
        return '';
    }
    switch (requiredUnit) {
        case UNIT_FOOT: {
            const convertedValue = meterToFoot(value);
            return `${formatNumberToString(convertedValue, decimals)} ${UNIT_FOOT}`;
        }
        case UNIT_MILE: {
            const convertedValue = meterToMile(value);
            return `${formatNumberToString(convertedValue, decimals)} ${UNIT_MILE}`;
        }
        case UNIT_KILOMETER: {
            const convertedValue = meterToKilometer(value);
            return `${formatNumberToString(convertedValue, decimals)} ${UNIT_KILOMETER}`;
        }
        case UNIT_METER:
        default:
            return `${formatNumberToString(value, decimals)} ${UNIT_METER}`;
    }
};
// Default unit: mm
// Other allowed units: in, cm, m
export const getConvertedPrecipitation = (value, requiredUnit, decimals) => {
    if (!isValidNum(value)) {
        return '';
    }
    switch (requiredUnit) {
        case UNIT_CENTIMETER: {
            const convertedValue = millimeterToCentimeter(value);
            return `${formatNumberToString(convertedValue, decimals)} ${UNIT_CENTIMETER}`;
        }
        case UNIT_METER: {
            const convertedValue = millimeterToMeter(value);
            return `${formatNumberToString(convertedValue, decimals)} ${UNIT_METER}`;
        }
        case UNIT_INCH: {
            const convertedValue = millimeterToInch(value);
            return `${formatNumberToString(convertedValue, decimals)} ${UNIT_INCH}`;
        }
        case UNIT_MILLIMETER:
        default:
            return `${formatNumberToString(value, decimals)} ${UNIT_MILLIMETER}`;
    }
};
// Default unit: °
// Other allowed units: °'"
export const getConvertedLocation = (value, requiredUnit, decimals) => {
    if (!isValidNum(value)) {
        return '';
    }
    switch (requiredUnit) {
        case UNIT_DMS: {
            // DMS will ignore decimals, and return 0 decimals for seconds
            const [d, m, s] = degreeToDms(value);
            return `${d}° ${m}' ${formatNumberToString(s, 0)}"`;
        }
        case UNIT_DEGREE:
        default:
            return `${formatNumberToString(value, decimals)}°`;
    }
};
// Default unit: °
export const getConvertedDirection = (value, requiredUnit, decimals) => {
    if (!isValidNum(value)) {
        return '';
    }
    switch (requiredUnit) {
        case UNIT_DEGREE:
        default:
            return `${formatNumberToString(value, decimals)}°`;
    }
};
// Default unit: m
// Other allowed units: ft
export const getConvertedRunwayLength = (value, requiredUnit, decimals) => {
    if (!isValidNum(value)) {
        return '';
    }
    switch (requiredUnit) {
        case UNIT_FOOT: {
            const convertedValue = meterToFoot(value);
            return `${formatNumberToString(convertedValue, decimals)} ${UNIT_FOOT}`;
        }
        case UNIT_METER:
        default:
            return `${formatNumberToString(value, decimals)} ${UNIT_METER}`;
    }
};
// Default unit: m
// Other allowed units: ft
export const getConvertedRunwayVisualRange = (value, requiredUnit, decimals) => {
    if (!isValidNum(value)) {
        return '';
    }
    switch (requiredUnit) {
        case UNIT_FOOT: {
            const convertedValue = meterToFoot(value);
            return `${formatNumberToString(convertedValue, decimals)} ${UNIT_FOOT}`;
        }
        case UNIT_METER:
        default:
            return `${formatNumberToString(value, decimals)} ${UNIT_METER}`;
    }
};
// Default unit: sec
export const getConvertedTime = (value, requiredUnit, decimals) => {
    if (!isValidNum(value)) {
        return '';
    }
    switch (requiredUnit) {
        case UNIT_SECOND:
        default:
            return `${formatNumberToString(value, decimals)} ${UNIT_SECOND}`;
    }
};
// Default unit: kg
// Other allowed units: lb
export const getConvertedMass = (value, requiredUnit, decimals) => {
    if (!isValidNum(value)) {
        return '';
    }
    switch (requiredUnit) {
        case UNIT_POUND: {
            const valueInPounds = kilogramToPound(value);
            const convertedValue = value * getMassUnitConverter(valueInPounds, UNIT_POUND).conversionFactor;
            return `${formatNumberToString(convertedValue, decimals)} ${UNIT_POUND}`;
        }
        case UNIT_KILO_GRAM:
        default: {
            const convertedValue = value * getMassUnitConverter(value, UNIT_KILO_GRAM).conversionFactor;
            return `${formatNumberToString(convertedValue, decimals)} ${UNIT_TONNE}`;
        }
    }
};
// List of conversion factors from kilograms to higher units based unit profile(UNIT_POUND, UNIT_KILOGRAM)
const higherUnitConversionFactors = [
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_TONNE,
        conversionFactor: Math.pow(10, -3),
        unitProfile: UNIT_KILO_GRAM,
    },
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_GIGA_GRAM,
        conversionFactor: Math.pow(10, -6),
        unitProfile: UNIT_KILO_GRAM,
    },
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_TERA_GRAM,
        conversionFactor: Math.pow(10, -9),
        unitProfile: UNIT_KILO_GRAM,
    },
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_PETA_GRAM,
        conversionFactor: Math.pow(10, -12),
        unitProfile: UNIT_KILO_GRAM,
    },
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_US_TONNE,
        conversionFactor: KILOGRAM_TO_POUNDS_CONVERSION_FACTOR * 0.5 * Math.pow(10, -3),
        unitProfile: UNIT_POUND,
    },
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_KILO_US_TONNE,
        conversionFactor: KILOGRAM_TO_POUNDS_CONVERSION_FACTOR * 0.5 * Math.pow(10, -6),
        unitProfile: UNIT_POUND,
    },
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_MEGA_US_TONNE,
        conversionFactor: KILOGRAM_TO_POUNDS_CONVERSION_FACTOR * 0.5 * Math.pow(10, -9),
        unitProfile: UNIT_POUND,
    },
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_GIGA_US_TONNE,
        conversionFactor: KILOGRAM_TO_POUNDS_CONVERSION_FACTOR * 0.5 * Math.pow(10, -12),
        unitProfile: UNIT_POUND,
    },
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_TERA_US_TONNE,
        conversionFactor: KILOGRAM_TO_POUNDS_CONVERSION_FACTOR * 0.5 * Math.pow(10, -15),
        unitProfile: UNIT_POUND,
    },
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_PETA_US_TONNE,
        conversionFactor: KILOGRAM_TO_POUNDS_CONVERSION_FACTOR * 0.5 * Math.pow(10, -18),
        unitProfile: UNIT_POUND,
    },
];
// List of conversion factors from kilograms to lower units based unit profile(UNIT_POUND, UNIT_KILOGRAM)
const lowerUnitCOnversionFactors = [
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_GRAM,
        conversionFactor: Math.pow(10, 3),
        unitProfile: UNIT_KILO_GRAM,
    },
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_MILLI_GRAM,
        conversionFactor: Math.pow(10, 6),
        unitProfile: UNIT_KILO_GRAM,
    },
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_MICRO_GRAM,
        conversionFactor: Math.pow(10, 9),
        unitProfile: UNIT_KILO_GRAM,
    },
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_NANO_GRAM,
        conversionFactor: Math.pow(10, 12),
        unitProfile: UNIT_KILO_GRAM,
    },
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_PICO_GRAM,
        conversionFactor: Math.pow(10, 15),
        unitProfile: UNIT_KILO_GRAM,
    },
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_OUNCE,
        conversionFactor: KILOGRAM_TO_POUNDS_CONVERSION_FACTOR * POUNDS_TO_OUNCE_CONVERSION_FACTOR,
        unitProfile: UNIT_POUND,
    },
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_MILLI_OUNCE,
        conversionFactor: KILOGRAM_TO_POUNDS_CONVERSION_FACTOR * POUNDS_TO_OUNCE_CONVERSION_FACTOR * Math.pow(10, 3),
        unitProfile: UNIT_POUND,
    },
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_MICRO_OUNCE,
        conversionFactor: KILOGRAM_TO_POUNDS_CONVERSION_FACTOR * POUNDS_TO_OUNCE_CONVERSION_FACTOR * Math.pow(10, 6),
        unitProfile: UNIT_POUND,
    },
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_NANO_OUNCE,
        conversionFactor: KILOGRAM_TO_POUNDS_CONVERSION_FACTOR * POUNDS_TO_OUNCE_CONVERSION_FACTOR * Math.pow(10, 9),
        unitProfile: UNIT_POUND,
    },
    {
        from: UNIT_KILO_GRAM,
        to: UNIT_PICO_OUNCE,
        conversionFactor: KILOGRAM_TO_POUNDS_CONVERSION_FACTOR * POUNDS_TO_OUNCE_CONVERSION_FACTOR * Math.pow(10, 12),
        unitProfile: UNIT_POUND,
    },
];
export const getMassUnitConverter = (value, unitProfile) => {
    let toUnit = unitProfile;
    let conversionFactor = 1;
    if (value >= 100000) {
        higherUnitConversionFactors.forEach(each => {
            if (each.unitProfile === unitProfile && value >= 100000) {
                value = value / 1000;
                toUnit = each.to;
                conversionFactor = each.conversionFactor;
            }
        });
    }
    if (value <= 100) {
        lowerUnitCOnversionFactors.forEach(each => {
            if (each.unitProfile === unitProfile && value < 100) {
                value = value * 1000;
                toUnit = each.to;
                conversionFactor = each.conversionFactor;
            }
        });
    }
    return { from: UNIT_KILO_GRAM, to: toUnit, conversionFactor, unitProfile };
};
//# sourceMappingURL=unitsOfMeasurement.js.map